import React, { useState } from "react";
import { useAuth } from "hooks/useAuth";

// Компонент керування та копіювання токену доступу сторінки "Панель адміністратора"
const GetTokenButton = () => {
  // Використовуємо хук useAuth для отримання токену
  const { token } = useAuth();
  // Локальний стан відображення повідомлення "Скопійовано!"
  const [copied, setCopied] = useState(false);

  // Функція копіювання токену
  const handleCopyToken = async () => {
    if (!token) return; // Не робити нічого, якщо токену немає
    try {
      await navigator.clipboard.writeText(token);
      setCopied(true);
      // Ховаємо повідомлення через 2 секунди
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Не вдалося скопіювати токен:", err);
    }
  };

  return (
    <button className="copy-token-button" onClick={handleCopyToken} disabled={copied}>
      {copied ? "Скопійовано!" : "Отримати токен"}
    </button>
  );
};

export default GetTokenButton;
